import { ShapeState } from "./types";
import { UmbrellaModel } from "@/models/products/umbrella";

export const setModel = (state: ShapeState, value: UmbrellaModel) => {
  state.model = value;
};
